import Spinner from "components/common/Spinner/Spinner";
import { useAppSelector } from "redux/hooks";

const Loader = () => {
  const showExportLoader = useAppSelector((state) => state.Export.showExportLoader);

  const planAssignmentLoadingCount = useAppSelector((state) => state.PlanAssignment.loadingCount);
  const libraryLoadingCount = useAppSelector((state) => state.Library.loadingCount);
  const releaseHighlightsLoadingCount = useAppSelector((state) => state.ReleaseHighlights.loadingCount);

  const corpLoader = useAppSelector((state) => state.CorpDashboard.corpLoader);
  const feedbackLoader = useAppSelector((state) => state?.feedback?.feedbackLoader);
  const summaryLoader = useAppSelector((state) => state.CorpDashboard.summaryLoader);
  const overviewLoader = useAppSelector((state) => state.CorpDashboard.overviewLoader);

  const showLoader = useAppSelector((state) => state.filters.showLoader);

  const hotelUserDashboardLoadingCount = useAppSelector((state) => state.hotelUserDashboardSlice.loadingCount);

  const showOnboardingWizard = useAppSelector((state) => state.onboardingResponse.showOnboardingWizard);
  const showWizardLoader = useAppSelector((state) => state.onboardingResponse.showWizardLoader);

  const suggestedPlansLoadingCount = useAppSelector((state) => state.suggestedPlans.loadingCount);

  const editEmailLoader = useAppSelector((state) => state.app.editEmailLoader);

  const myPlanShowLoader = useAppSelector((state) => state.myplans.MyPlans.myPlanShowLoader);

  const smeShowLoader = useAppSelector((state) => state.sme.smeShowLoader);
  const planDetailShowLoader = useAppSelector((state) => state.planDetails.planDetailShowLoader);

  const myPlanDetailShowLoader = useAppSelector((state) => state.myPlanDetails?.myPlanDetailShowLoader);
  const userValidationCheckLoader = useAppSelector((state) => state.myPlanDetails?.userValidationCheckLoader);

  const abovePropertyLoader = useAppSelector((state) => state.aboveProperty?.abovePropertyLoader);
  const bookmarkLoader = useAppSelector((state) => state.aboveProperty?.bookmarkLoader);

  const showIndividualUserLoader = useAppSelector((state) => state.individualUser.showIndividualUserLoader);
  const showIndividualPropertyLoader = useAppSelector((state) => state.individualProperty.showIndividualPropertyLoader);

  const planShowLoader = useAppSelector((state) => state.plans?.planShowLoader);
  const actionShowLoader = useAppSelector((state) => state.individualAction.actionShowLoader);

  const bookmarkShowLoader = useAppSelector((state) => state.bookmarkedPlans.bookmarkShowLoader);

  const adminConsoleLoader = useAppSelector((state) => state.adminConsole.adminConsoleLoader);
  const isPinLoader = useAppSelector((state) => state.PropertyOverviewSlice.isPinLoader);
  const suggestionsLoader = useAppSelector((state) => state.manageSuggestions.suggestionsLoader);

  return (
    (myPlanShowLoader ||
      libraryLoadingCount > 0 ||
      planAssignmentLoadingCount > 0 ||
      releaseHighlightsLoadingCount > 0 ||
      abovePropertyLoader ||
      showIndividualUserLoader ||
      showIndividualPropertyLoader ||
      showExportLoader ||
      planShowLoader ||
      planDetailShowLoader ||
      myPlanDetailShowLoader ||
      bookmarkShowLoader ||
      (hotelUserDashboardLoadingCount > 0 && !showOnboardingWizard) ||
      actionShowLoader ||
      smeShowLoader ||
      corpLoader ||
      summaryLoader ||
      overviewLoader ||
      showLoader ||
      showWizardLoader ||
      editEmailLoader ||
      userValidationCheckLoader ||
      adminConsoleLoader ||
      isPinLoader ||
      userValidationCheckLoader ||
      bookmarkLoader ||
      suggestionsLoader ||
      suggestedPlansLoadingCount > 0 ||
      feedbackLoader) && <Spinner backdropVisible />
  );
};

export default Loader;
